import React, { FC } from 'react';
import { RequirementsProps } from '../../../../tools/context';
import { useTranslation } from '../../../../tools/i18n';
import { getFormattedEuro } from '../../../../tools/tools';
import ButtonV2 from '../../../ButtonV2';
import { useTravelPlannerResultsContext } from '../../TravelPlanerResultsContext';

interface PriceBoxProps {
  requirement: RequirementsProps;
}

const getSpotValues = (data: any): any[] => {
  return Object.values(data).map((jour) => {
    return jour[0].value[0];
  });
};
const PriceBox: FC<PriceBoxProps> = ({ requirement }) => {
  const { t } = useTranslation();
  const { inputs, formattedData } = useTravelPlannerResultsContext();
  const spots = getSpotValues(formattedData);

  const calculateTripNightCount = (): number | null => {
    if (spots.some((spot) => !spot.nightsPerSpot)) {
      console.warn("Some night missing in the trip, can't calculate nights");
      return null;
    }
    return spots.reduce((sum, spot) => {
      const night = spot?.nightsPerSpot ? spot.nightsPerSpot : 0;
      return Number(sum + night);
    }, 0);
  };

  const calculateTripPrice = (): number | null => {
    if (spots.some((spot) => !spot.price)) {
      console.warn("Some price missing in the trip, can't calculate price");
      return null;
    }
    return spots.reduce((sum, spot) => {
      const price = spot?.price ? Number(parseFloat(spot.price).toFixed(2)) : 0;
      return Number((sum + price).toFixed(2));
    }, 0);
  };

  const tripPrice = calculateTripPrice();
  const tripNightCount = calculateTripNightCount();

  const saveCart = () => {
    const subDomain = requirement.environment === 'prod' ? '' : 'staging.';
    const cartUrl = `https://${subDomain}checkout.bivouacs.huttopia.com/fr-FR/cart-multi`;
    let urlParams = `?equipment=${inputs.travelerProfile.equipment}&adults=${inputs.travelerProfile.adultCount}`;
    inputs.travelerProfile.childrenAges.map((c) => (urlParams += `&children[]=${c}`));
    spots.map((s) => (urlParams += `&site[]=${s.id}&from[]=${s.startDate}&to[]=${s.endDate}`));
    window.location.href = `${cartUrl}${urlParams}`;
  };

  if (!tripPrice || !tripNightCount) return null;
  return (
    <div className="price-box">
      <div className="label">
        <p>{`${tripNightCount} ${t('travelPlaner.priceBox.label')}`}</p>
        <p className="price">{getFormattedEuro(tripPrice)}</p>
      </div>
      <ButtonV2
        key={'travelPlaner.nightDayHeader.basketbutton'}
        text={t('travelPlaner.priceBox.basketbutton')}
        onClick={saveCart}
        className="basketButton"
      />
    </div>
  );
};

export default PriceBox;
